export enum ERROR_MODALS {
    INCORRECT_EXTENSION = "INCORRECT_EXTENSION",
    LIMIT_WORKERS = "LIMIT_WORKERS",
    FORMAT_ERRORS = "FORMAT_ERRORS",
    FORMAT_COLUMNS_ERRORS = "FORMAT_COLUMNS_ERRORS",
}

export enum ERRORS_LIST {
    MORE_THAN_200_WORKERS = "MORE_THAN_200_WORKERS",
    WORKER_EXCEEDS_AGE = "WORKER_EXCEEDS_AGE",
    WORKER_EXCEEDS_SALARY = "WORKER_EXCEEDS_SALARY",
}

export type ErrorFormats = {
    campo: string;
    column: number;
    error: string;
    line: number;
};

export const FORMAT_ERRORS = {
    INVALID_DOCUMENT: "DOCUMENTO INVALIDO",
    EMPTY: "VACIO",
    INVALID_CHAR: "MAX. 30 Y/O CARACTER INVALIDO",
    DUPLICATED_DOCUMENT: "DOCUMENTO REPETIDO",
    INVALID_TYPE_DOCUMENT: "TIPO DOCUMENTO INVALIDO",
    INVALID_BIRTHDAY: "CAMBIA FORMATO CELDA A TIPO FECHA",
    INVALID_AGE: "EDAD MENOR A 18",
    INVALID_SALARY: "MONTO MENOR A S/ 40.0",
};

export const COLUMN_NAMES = {
    DOCUMENT_NUMBER: "NÚMERO DE DOCUMENTO DE IDENTIDAD",
    LAST_NAME: "APELLIDO PATERNO",
    TYPE_DOCUMENT: "CÓDIGO DE TIPO DOCUMENTO",
    NATIONALITY: "NACIONALIDAD",
    BIRTHDAY: "FECHA DE NACIMIENTO",
    SECOND_LAST_NAME: "APELLIDO MATERNO",
    NAME: "PRIMER NOMBRE",
    SALARY: "IMPORTE SUELDO",
};

export const COLUMN_ERRORS = {
    [COLUMN_NAMES.DOCUMENT_NUMBER]:
        "Error en la columna “Número de Documento de Identidad”",
    [COLUMN_NAMES.LAST_NAME]: "Error en la columna “Apellido paterno”",
    [COLUMN_NAMES.TYPE_DOCUMENT]:
        "Error en la columna “Código de tipo documento”",
    [COLUMN_NAMES.NATIONALITY]: "Error en la columna “Nacionalidad”",
    [COLUMN_NAMES.BIRTHDAY]: "Error en la columna “Fecha de nacimiento”",
    [COLUMN_NAMES.SECOND_LAST_NAME]: "Error en la columna “Apellido materno”",
    [COLUMN_NAMES.NAME]: "Error en la columna “Primer nombre”",
    [COLUMN_NAMES.SALARY]: "Error en la columna “Importe sueldo”",
};
